import {
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  Typography,
  Button,
} from '@ui/components';
import { useEmployeesMassImportStore } from '@pages/employees/stores';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

export const EmployeesMassImportRemove: FC = () => {
  const { t } = useTranslation();
  const { resetFile, showSummary } = useEmployeesMassImportStore();

  return (
    <DialogContent className="max-w-xl">
      <DialogHeader>
        <DialogTitle>{t('EMPLOYEES.MASS_IMPORT.REMOVE_IMPORT.TITLE')}</DialogTitle>
      </DialogHeader>

      <section className="p-4 space-y-8">
        <Typography variant="paragraphBasicBook">
          {t('EMPLOYEES.MASS_IMPORT.REMOVE_IMPORT.DESCRIPTION')}
        </Typography>
      </section>

      <DialogFooter>
        <Button onClick={showSummary} variant="tertiary" size="large" wide>
          {t('EMPLOYEES.MASS_IMPORT.REMOVE_IMPORT.CANCEL')}
        </Button>
        <Button onClick={resetFile} variant="primary" size="large" wide>
          {t('EMPLOYEES.MASS_IMPORT.REMOVE_IMPORT.REMOVE')}
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};
